var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-filter", {
    attrs: {
      "status-options": _vm.statuses,
      "date-mode": "range",
      "show-team-members": _vm.showTeamMembers,
      "show-carriers": true,
      "show-customer-filter": true,
      "show-quoting-status": _vm.showQuotingStatus,
      "show-blank-date-toggle": true,
      "show-status-filter": _vm.showStatus,
      clearable: false,
      "team-region-id": _vm.teamRegionId,
      "initial-filters": _vm.initialFilters,
      "status-test-id": "shipment-status",
      "from-date-test-id": "start-date",
      "to-date-test-id": "end-date",
      "default-status": "Active",
      "blank-date-label": "Show shipments with no date first",
      domain: "shipments",
    },
    on: { onFilterShipments: _vm.handleFilterShipments },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }